// @ts-nocheck
/* eslint-disable */
import { setItem, getItem } from "~/es6/localstorage";
import { makeEvent } from "~/lib/signals";
import { _ } from "~/i18n";

/**
 * zobrazeni souradnic ve slideru
 * @signal gps-format-changed změna formatu souradnic
 */
Mapy.GPS = class {
	constructor() {
		this._formatIndex = 0;
		this._const = {
			LS_KEY: "gpsFormatindex"
		};
		this._formats = [
			_("module.gps.formats.wgs84_v1"),
			_("module.gps.formats.wgs84_v2"),
			_("module.gps.formats.wgs84_v3"),
			_("module.gps.formats.olc"),
			_("module.gps.formats.mgrs")
		];
		this._count = this._formats.length;
		var item = getItem(this._const.LS_KEY);
		this._formatIndex = item ? parseInt(item, 10) : 0;
	}

	/**
	 * Navrati format souradnic
	 * @param {Array} gps - souradnice ve formatu WGS84
	 * @param {Integer} index - index pozadovaneho formatu
	 */
	_formatGPS(gps, index) {
		switch (index) {
			case 0:
				return gps.reverse().join(", ").replace(/°/g,"");
			case 1:
				var out = [];
				for(var i = 0; i < 2; i++){
					var len = gps[i].length;
					var ch = gps[i].substring(len - 1,len);
					out.push(ch + " " + gps[i].replace(/°/g,"°").replace(/[A-Z]/g,""));
				}
				var gps = out;
			default:
				return gps.reverse().join(", ");
		}
	}

	/**
	 * Formatovani souradnic - ind odpovida indexum nahore.
	 * @param  {SceneCoords} coords
	 * @param  {int} ind Index formatu
	 * @return {String}
	 */
	_formatCoords(coords, ind) {
		var output = "";

		if (typeof ind === "undefined") {
			ind = -1;
		}

		if (coords) {
			switch (ind) {
				case 0:
				case 1:
				case 2:
					output = this._formatGPS(coords.toWGS84(ind), ind);
				break;

				case 3:
					output = coords.toOLC();
				break;

				case 4:
					output = coords.toMGRS();
				break;
			}
		}

		return output;
	}

	/**
	 * Vrati celkovy pocet formatu GPS
	 * @return {int}
	 */
	getFormatsCount() {
		return this._count;
	}

	/**
	 * Vrati aktualni index formatu, ktery se pouziva
	 * @return {int}
	 */
	getFormatIndex() {
		return this._formatIndex;
	}

	getFormatTrans(formatIndex) {
		return this._formats[formatIndex];
	}

	/**
	 * Nastavi novy index formatu souradnic
	 * @param {int} formatIndex
	 */
	setFormatIndex(formatIndex) {
		formatIndex = formatIndex || 0;

		if (formatIndex == this._formatIndex) return;

		if (formatIndex < 0 || formatIndex > this._count) {
			formatIndex = 0;
		}

		this._formatIndex = formatIndex;

		setItem(this._const.LS_KEY, this._formatIndex);

		makeEvent("gps-format-changed", this, {
			format: this._formats[formatIndex]
		});
	}

	/**
	 * Vrati pole s prepocitanymi souradnicemi pro vsechny formaty
	 * @param  {SceneCoords} coords
	 * @return {Array}
	 */
	coordsToAllFormats(coords) {
		var count = this.getFormatsCount();
		var all = [];

		for (var i = 0; i < count; i++) {
			all.push(this._formatCoords(coords, i));
		}

		return all;
	}

	/**
	 * Prepocet souradnic do formatu, ktery je aktualne zvoleny (formatIndex)
	 * @param  {SceneCoords} coords
	 * @return {String}
	 */
	coordsToFormat(coords) {
		if (coords) {
			return this._formatCoords(coords, this.getFormatIndex());
		}
		else return null;
	}
};
